import {IStationApi} from '../../api/station-api.service';
import {IStation, IPrecipitationNorm, ITemperatureNorm} from '../../api/api.types';
import {IS3UploadService} from '../../utils/s3-upload.service';
import {StateParams} from 'angular-ui-router';
import {IImomoErrorService} from '../../error/error.service';

export interface IStationHistoricNormStateParams extends StateParams {
  stationId: string;
}

export namespace IMeteostationHistoricNormEvents {
  export const NEW_DATA_UPLOADED = 'imomo-organization-change';
}

export default class StationHistoricNormController {
  static $inject = ['stationApi', 's3UploadService', '$stateParams', '$scope', 'imomoErrorService', '$rootScope'];
  private station: IStation;
  private isHistoricalDataLoading:boolean = false;
  private historicDataUrl:string;

  constructor(
    private stationApi:IStationApi,
    private s3UploadService:IS3UploadService,
    $stateParams:IStationHistoricNormStateParams,
    private $scope:ng.IScope,
    private imomoErrorService: IImomoErrorService,
    private $rootScope: ng.IRootScopeService
  ) {

    const stationId = Number.parseInt($stateParams.stationId);

    this.stationApi.getMeteoStation({stationId}).then((station) => {
      this.station = station;
      this.$rootScope.$broadcast('STATION_LOADED', station);
    }).finally(() => {
    });
  }

  uploadNewData($file:File) {
    if ($file) {
      this.isHistoricalDataLoading = true;
      this.stationApi.uploadHistoricMeteoData(this.station.id, $file)
      .then(() => {
        this.$scope.$broadcast(IMeteostationHistoricNormEvents.NEW_DATA_UPLOADED);
        this.isHistoricalDataLoading = false;
      }).catch((error) => {
        this.imomoErrorService.showErrorDetailsDialog(error.data.details);
        this.isHistoricalDataLoading = false;
      });
    }
  }


  private downloadHistoricMeteoData(): ng.IPromise<void> {
    this.isHistoricalDataLoading = true;
    return this.stationApi.getStationHistoricMeteoDataXLSX(this.station.id)
       .finally(() => {
          this.isHistoricalDataLoading = false;
        });
  }
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/historic-norm/historic-norm.controller.ts
 **/